module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("使用案例")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("如果你的产品在使用"), _c('code', [_vm._v("VUX")]), _vm._v(", 请直接发 PR 修改 "), _c('code', [_vm._v("docs/zh-CN/about/showcase.md")]), _vm._v("（置于列表最后，统一格式：二维码必须无白边框）。")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://ws1.sinaimg.cn/large/663d3650gy1fpwihri9hzj2066066dgb.jpg",
      "width": "150"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://ws1.sinaimg.cn/large/663d3650gy1fpwii8udl7j2088088jrj.jpg",
      "width": "150"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://ws1.sinaimg.cn/large/663d3650gy1fpwiiq61ihj207v07vjr8.jpg",
      "width": "150"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://ws1.sinaimg.cn/large/663d3650gy1fpwij2qezej2066066dfy.jpg",
      "width": "150"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://ws1.sinaimg.cn/large/663d3650gy1fpwijfw73zj20aa0aaaa9.jpg",
      "width": "150"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://ws1.sinaimg.cn/large/663d3650gy1fpwijtrvp1j20do0do4gp.jpg",
      "width": "150"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://ws1.sinaimg.cn/large/663d3650gy1fpwike27c8j207c07cdg4.jpg",
      "width": "150"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://ws1.sinaimg.cn/large/663d3650gy1fpwikqk1xwj2088088myl.jpg",
      "width": "150"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://ws1.sinaimg.cn/large/663d3650gy1fpwil30l2oj20b40b4wf0.jpg",
      "width": "150"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://ws1.sinaimg.cn/large/663d3650gy1fpwilfmz9xj20aa0aaacp.jpg",
      "width": "150"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://ws1.sinaimg.cn/large/663d3650gy1fpwilte2naj20aa0aajru.jpg",
      "width": "150"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://ws1.sinaimg.cn/large/663d3650gy1fpwim77oc5j2064066gnh.jpg",
      "width": "150"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://ws1.sinaimg.cn/large/663d3650gy1fpwimm8dtkj208508cqjf.jpg",
      "width": "150"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://ws1.sinaimg.cn/large/663d3650gy1fpmuvjf5x6j208c08c74f.jpg",
      "width": "150"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://common-1251785959.cosbj.myqcloud.com/mdachu.jpg",
      "width": "150"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://img.yw0511.com/others/1528080310.png",
      "width": "150",
      "alt": "原味生活"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "http://images.wumakeji.com/niuxiaoyun/1528080310.jpg",
      "width": "150",
      "alt": "牛小云"
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4034ddec", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-4034ddec"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/showcase-59.vue
// module id = 2176
// module chunks = 402